class CartNotification extends HTMLElement {
  constructor() {
    super();

    const _this = this;
    this.cartObject = null;
    this.banItems = [6851464331307, 6851464691755];
    this.banAddedItems = [];
    this.notification = document.getElementsByTagName('cart-notification')[0];
    this.cartIcon = document.getElementById('cart-icon-bubble');
    this.cartIcon.addEventListener('click', function(e) {
      e.preventDefault();
      _this.getCart(true)
    });
    this.cartOverlay = document.getElementById('cart-overlay');
    this.cartOverlay.addEventListener('click', function(e) {
      _this.closeCart();
    });
    this.cartClose = document.querySelector('.cart-close');
    this.cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    this.cartItems = document.querySelector('cart-notification .cart-items');
    this.itemTemplate = document.getElementById('cart-item-template').innerHTML;
    this.rebuyWidget = this.notification.querySelector('[data-rebuy-id]');

    this.giftModifier = this.notification.querySelector('[name="attributes[is-gift]"]');
    this.giftForm = this.notification.querySelector('.cart-attributes');
    this.giftEnabled = false;
    this.initGift();

    this.checkoutBtn = this.notification.querySelector('.cart-bottom .button');
    this.initSubmit();

    this.priceReplacement = this.notification.querySelector('.cart-total__price');
    this.hasSubscription = false;
    this.subPrices = 0;
    this.regularPrices = 0;
    this.shippingProgressBar = this.notification.querySelector('.shipping-progress');
    this.shippingProgressBar.querySelector('.shipping-progress-percent').style.width = '0%';
    this.shippingProgressBar.querySelector('.shipping-progress-bar').classList.add('disable');
    this.hasNurseProducts = false;
    this.hasTargetProducts = false;

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && document.body.classList.contains('cart-opened')) {
        this.closeCart()   
      }
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getCart(checkBan=false) {
    document.querySelector('body').classList.add('cart-opened', 'loading');
    this.checkoutBtn.setAttribute('disabled', true);
    fetch(`${routes.cart_url}`, { ...fetchConfig('javascript', 'GET') })
      .then((response) => response.json())
      .then((cart) => {
        this.openSideCart(cart)
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('body').classList.remove('loading');
        this.checkoutBtn.removeAttribute('disabled');
      });
  }

  bulkUpdate(body) {
    fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript', 'POST'), body })
      .then((response) => response.json())
      .then((cart) => {
        this.openSideCart(cart);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  checkRebuyWidgets() {
    if (typeof Rebuy != 'undefined' && Rebuy != null) {
      const _this = this;
      Rebuy.widgets.forEach((widget) => {
        widget.getWidgetProducts();
        widget.show();
        // setTimeout(function() {
        //   if ((typeof widget.data.metadata != 'undefined') && widget.data.metadata.matched_rules[0] && _this.cartObject.total_price >= 7500 && _this.banAddedItems.length == 0 && widget.data.products.length > 0)
        //     widget.show();
        //   else
        //     widget.hide();
        // }, 1000)
      });
    }
    var showWidget = false;
    var customTotal = 0;
    
    if(this.cartObject.items.filter(item => item.product_id == 4422175981611).length > 0) showWidget = true;
    this.cartObject.items.forEach((item) => {
      if( !item.product_type.includes('Piercing Services') && 
        !item.product_type.includes('Device Piercing') && 
        !item.product_type.includes('Needle Piercing') && 
        !item.product_type.includes('Needle Piercing Services') && 
        !item.title.includes('Flat Back') 
      ) customTotal += item.final_line_price;
    });
    if(customTotal > 100 * 100) showWidget = true;
    if (document.querySelector('#rebuy-widget-123886')) document.querySelector('#rebuy-widget-123886').classList.toggle('!hidden', !showWidget);

    // if(document.querySelector('#rebuy-widget-94091')) document.querySelector('#rebuy-widget-94091').classList.toggle('!hidden', this.cartObject.items.filter((item) => [40797142450219, 40797142482987].includes(item.variant_id)).length > 0);
  }

  // checkBannedItems(cart) {
  //   let items = [];
  //   cart.items.forEach((item) => {
  //     if(this.banItems.indexOf(item.product_id) > -1 || this.banItems.indexOf(item.id) > -1) items.push([item.id, item.quantity]);
  //   });
  //   return items
  // }
  // removeBannedItems(bannedItems) {
  //   const _this = this;
  //   let updates = {};
  //   bannedItems.forEach((bannedItem, index) => {
  //     if (_this.cartObject != null && _this.cartObject.total_price < 10000) {
  //       updates[bannedItem[0]] = 0;
  //     } else {
  //       if (bannedItems.length > 1 && index == bannedItems.length - 1)
  //         updates[bannedItem[0]] = 0;
  //       else if (bannedItem[1] > 1)
  //         updates[bannedItem[0]] = 1;
  //     }
  //   });
  //   const body = JSON.stringify({
  //     updates: updates
  //   });
  //   if (updates != {})
  //     fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript', 'POST'), body })
  //       .then((response) => response.json())
  //       .then((cart) => {
  //         this.openSideCart(cart);
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       });
  // }

  openSideCart(cart) {
    console.log(cart);
    
    this.cartObject = cart;
    if (cart.item_count > 0) {
      this.notification.classList.remove('cart-notification--empty');
      this.cartIcon.classList.remove('header__icon--cart__empty');
    } else {
      this.notification.classList.add('cart-notification--empty');
      this.cartIcon.classList.add('header__icon--cart__empty');
    }
    if (document.querySelector('.loop-onstore'))
      this.notification.classList.add('loop-enabled');
    else
      this.notification.classList.remove('loop-enabled');
    for (var i = 0; i < this.cartCountBubbles.length; i++) {
      const spans = this.cartCountBubbles[i].querySelectorAll('span');
      for (var j = 0; j < spans.length; j++) {
        spans[j].innerText = cart.item_count
      }
    }
    this.renderGiftForm(cart);
    this.renderCart(cart);

    this.cartClose.focus();
  }
  renderCart(cart) {
    const _this = this;
    this.hasNurseProducts = false;
    this.hasTargetProducts = false;
    fetch('/cart?view=ajax_cart', { method: 'GET' })
      .then((response) => response.json())
      .then((cartProductsResponse) => {
        const cartProducts = cartProductsResponse;
        _this.cartItems.innerHTML = '';
        for (var i = 0; i < cart.items.length; i++) {
          _this.cartItems.innerHTML = _this.cartItems.innerHTML + _this.itemTemplate
        }
        const items = _this.cartItems.querySelectorAll('.cart-item');
        for (var i = 0; i < cart.items.length; i++) {
          _this.renderItem(items[i], cart.items[i], cartProducts[cart.items[i].variant_id])
        }
        _this.rebuyWidget.innerHTML = '';
        _this.rebuyWidget.removeAttribute('data-initialized');
        _this.attachEvents();
        if (_this.hasNurseProducts == true && _this.cartObject.total_price < 5000) {
          _this.checkoutBtn.textContent = 'Minimum order is $50'
        } else {
          _this.checkoutBtn.textContent = 'Continue to checkout'
        }
        _this.priceReplacement.innerHTML = this.getTotalPriceText();
        _this.updateProgressBar();	
      })
      .catch((e) => {
        console.error(e);
      })
  }
  renderItem(newElement, item, product=null) {
    let presale_msg = null;
    if (product) {
      presale_msg = product.presale_msg;
      if (product.product) product = product.product;
    }

    newElement.querySelector('.cart-item-image').href = item.url;
    newElement.querySelector('.cart-item-image').innerHTML = `<img src="${item.image.replace('.jpg', '_250x250.jpg').replace('.png', '_250x250.png')}" alt="${item.product_title}" />`;
    newElement.querySelector('.cart-item-header__left a').href = item.url;
    newElement.querySelector('.cart-item-header__left a').textContent = item.properties && item.properties.subscription_id ? 'Rowan Earring Club' : item.product_title;
    newElement.querySelector('.cart-item__price').innerHTML = `$${parseFloat(item.line_price / 100.0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
    if (item.original_line_price > item.line_price || 
      (item.properties['Compare Price'] && parseFloat(item.properties['Compare Price'].replace('$', '')) * 100 > item.final_price)
    ) {
      newElement.querySelector('.cart-item__price-dicounted').innerHTML = (item.properties['Compare Price'] && parseFloat(item.properties['Compare Price'].replace('$', '')) * 100 > item.final_price) ? `$${parseFloat(item.properties['Compare Price'].replace('$', '')) * item.quantity}` : `$${item.original_line_price / 100.0}`;
      newElement.querySelector('.cart-item__price').classList.add('!text-sale');
    }
    if (item.variant_title != 'Default Title') {
      if (item.properties && item.properties.subscription_id && item.properties.subscription_duration) {
        let variantTitle = `${item.variant_title} | ${item.properties.subscription_duration} ${item.properties.shipping_interval_unit_type}s`;
        if (item.product_title.toLowerCase().indexOf('prepaid') > -1) variantTitle += ' Pre-Paid';
        newElement.querySelector('.cart-item__variant').innerHTML = variantTitle;
      } else
        if (item.product_title && item.product_title.toLowerCase().indexOf('birthstone') > -1) {
          let variantTitle = item.variant_title.replace('Gold', 'Gold Vermeil').replace('Silver', 'Sterling Silver');
          if (item.product_title.indexOf('January') > -1)
            variantTitle += ' | Garnet';
          else if (item.product_title.indexOf('February') > -1)
            variantTitle += ' | Amethyst';
          else if (item.product_title.indexOf('March') > -1)
            variantTitle += ' | Aquamarine';
          else if (item.product_title.indexOf('April') > -1)
            variantTitle += ' | Crystal';
          else if (item.product_title.indexOf('May') > -1)
            variantTitle += ' | Emerald';
          else if (item.product_title.indexOf('June') > -1)
            variantTitle += ' | Alexandrite';
          else if (item.product_title.indexOf('July') > -1)
            variantTitle += ' | Ruby';
          else if (item.product_title.indexOf('August') > -1)
            variantTitle += ' | Peridot';
          else if (item.product_title.indexOf('September') > -1)
            variantTitle += ' | Sapphire';
          else if (item.product_title.indexOf('October') > -1)
            variantTitle += ' | Light Tourmaline';
          else if (item.product_title.indexOf('November') > -1)
            variantTitle += ' | Topaz';
          else if (item.product_title.indexOf('December') > -1)
            variantTitle += ' | Blue Zircon';
          newElement.querySelector('.cart-item__variant').innerHTML = variantTitle;
        } else
          newElement.querySelector('.cart-item__variant').innerHTML = item.variant_title;
    }
    if (product!=null) {
      if (product.tags.indexOf('nurse-marketplace') > -1) {
        newElement.querySelector('.cart-item__variant').innerHTML += newElement.querySelector('.cart-item__variant').innerHTML + '<br><span class="normal-case">Minimum order amount is $50.<br>If your order is less than $50, it will not ship.</span>';
        this.hasNurseProducts = true;
      } else if (product.tags.indexOf('target-marketplace') > -1) {
        this.hasTargetProducts = true;
      } else if (product.tags.indexOf('presale') > -1 && presale_msg) {
        // newElement.querySelector('.cart-item__variant').innerHTML += '<br><span>This item is for <b style="color: rgb(var(--color-base-accent-2));">PRESALE</b> and will ship in mid-June.</span>';
        newElement.querySelector('.cart-item__variant').innerHTML += `<br><br><span class="text-sale">${presale_msg}</span>`;
      }
    }
    if (item.discounts.length > 0) {
      item.discounts.forEach((discount) => {
        if (discount.title && discount.amount > 0) newElement.querySelector('.cart-item__variant').innerHTML += `<br><i>${discount.title}</i>`;
      });
    }
    if(item.properties && item.properties.__shopify_send_gift_card_to_recipient == 'on' && item.properties['Recipient email']) {
      newElement.querySelector('.cart-item__variant').innerHTML += `<br><span class="normal-case">Recipient email: ${item.properties['Recipient email']}</span>`;
      if(item.properties['Recipient name']) newElement.querySelector('.cart-item__variant').innerHTML += `<br><span class="normal-case">Recipient name: ${item.properties['Recipient name']}</span>`;
      if(item.properties['Send on']) newElement.querySelector('.cart-item__variant').innerHTML += `<br><span class="normal-case">Send on: ${item.properties['Send on']}</span>`;
      if(item.properties['Message']) newElement.querySelector('.cart-item__variant').innerHTML += `<br><span class="block text-ellipsis overflow-hidden whitespace-nowrap normal-case" style="width:170px;">Message: ${item.properties['Message']}</span>`;
    }


    if (item.properties != null && item.properties._attribution == 'Rebuy Product' && (item.properties._widget_id == '94091' || item.properties._widget_id == '123886') && item.final_line_price < item.original_line_price) newElement.querySelector('.cart-item__quantity').classList.add('!hidden');
    newElement.querySelector('input').dataset.id = item.variant_id;
    newElement.querySelector('input').dataset.key = item.key;
    newElement.querySelector('input[data-id="' + item.variant_id + '"]').value = item.quantity;
    newElement.querySelector('.cart-item__remove').dataset.id = item.variant_id;
    newElement.querySelector('.cart-item__remove').dataset.key = item.key;
    newElement.querySelector('.cart-qty__minus').dataset.key = item.key;
    newElement.querySelector('.cart-qty__plus').dataset.key = item.key;
  }

  getTotalPriceText() {
    this.hasSubscription = false;
    this.subPrices = 0;
    this.regularPrices = 0;
    let prices = [];
    for (var i = 0; i < this.cartObject.items.length; i++) {
      const item = this.cartObject.items[i];
      if (item.properties && item.properties.subscription_id) {
        if (item.properties.subscription_duration) {
          this.regularPrices += item.line_price;
        } else {
          this.subPrices += item.line_price;
        }
        this.hasSubscription = true;
      } else {
        this.regularPrices += item.line_price;
      }
    }
    if (this.regularPrices > 0) prices.push(`$${this.regularPrices / 100.0}`);
    if (this.subPrices > 0) prices.push(`$${this.subPrices / 100.0}/mo`);
    const wrapIn = document.querySelector('#ptw-wrapin');
    if (wrapIn) {
      if (this.hasSubscription)
        wrapIn.classList.add('hide');
      else
        wrapIn.classList.remove('hide');
    }
    if (this.hasSubscription) {
      if (document.getElementById('gift-giver')) {
        const element = document.getElementById('gift-giver');
        const attributes = this.cartObject.attributes;
        element.id = 'gift-email';
        element.name = 'attributes[gift-email]';
        element.type = 'email';
        element.closest('.grid__item').querySelector('label').innerHTML = 'Email address';
        element.value = attributes['gift-email'];
        element.value = element.value.replace('undefined', '');

        const firstElement = document.getElementById('gift-recipient');
        firstElement.closest('.grid__item').querySelector('label').innerHTML = 'Recipient name';
      }
    } else {
      if (document.getElementById('gift-email')) {
        const element = document.getElementById('gift-email');
        element.id = 'gift-giver';
        element.name = 'attributes[gift-giver]';
        element.type = 'text';
        element.closest('.grid__item').querySelector('label').innerHTML = 'From';

        const firstElement = document.getElementById('gift-recipient');
        firstElement.closest('.grid__item').querySelector('label').innerHTML = 'To';
      }
    }
    return prices.join(' + ')
  }
  updateProgressBar() {
    if(this.hasNurseProducts || this.hasTargetProducts) {
      this.shippingProgressBar.classList.add('hide');
    } else {
      this.shippingProgressBar.classList.remove('hide');
      const threshold = parseFloat(this.hasSubscription ? 0 : (this.shippingProgressBar.dataset.threshold || 15000));
      
      if (this.regularPrices < threshold) {
        this.shippingProgressBar.querySelector('.shipping-progress-desc').innerHTML = `You are $${(threshold-this.regularPrices) / 100.0} away from <b>FREE SHIPPING</b>`;
        this.shippingProgressBar.querySelector('.shipping-progress-bar').classList.remove('hide', 'disable');
        this.shippingProgressBar.querySelector('.shipping-progress-percent').style.width = `${this.regularPrices / threshold * 100.0}%`;
      } else {
        this.shippingProgressBar.querySelector('.shipping-progress-bar').classList.add('disable', 'hide');
        this.shippingProgressBar.querySelector('.shipping-progress-desc').innerHTML = '🎉 Congrats! You\'ve unlocked <b>FREE SHIPPING!</b>';
      }
    }
  }

  attachEvents() {
    const _this = this;
    let items = this.cartItems.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) {
      items[i].querySelector('.cart-qty__minus').addEventListener('click', function() {
        const input = this.closest('.cart-item__quantity').querySelector('input');
        _this.updateVariant(input.dataset.key, parseInt(input.value) - 1);
      });
      items[i].querySelector('.cart-qty__plus').addEventListener('click', function() {
        const input = this.closest('.cart-item__quantity').querySelector('input');
        _this.updateVariant(input.dataset.key, parseInt(input.value) + 1);
      });
      items[i].querySelector('input').addEventListener('change', function() {
        _this.updateVariant(this.dataset.key, parseInt(this.value));
      });
      items[i].querySelector('.cart-item__remove').addEventListener('click', function() {
        _this.updateVariant(this.dataset.key, 0);
      });
    }
    // if (typeof Rebuy != 'undefined' && Rebuy != null) Rebuy.init();
    _this.checkRebuyWidgets();
  }

  updateVariant(key, qty) {
    const body = JSON.stringify({
      'id': key,
      'quantity': qty
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig('javascript', 'POST'), body })
      .then((response) => response.json())
      .then((cart) => {
        this.cartObject = cart;
        this.openSideCart(cart);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('body').classList.remove('loading');
        this.checkoutBtn.removeAttribute('disabled');
      });
  }

  closeCart() {
    document.querySelector('body').classList.remove('cart-opened', 'rebuy-modal-visible');
    this.cartIcon.focus()
  }

  renderGiftForm(cart) {
    const attributes = cart.attributes;
    if (attributes['is-gift'] == "true") {
      this.giftEnabled = true;
      this.giftForm.querySelector('[name="attributes[is-gift]"]').checked = true;
      if (this.giftForm.querySelector('#gift-recipient')) this.giftForm.querySelector('#gift-recipient').value = attributes['gift-recipient'];
      if (this.giftForm.querySelector('#gift-giver')) this.giftForm.querySelector('#gift-giver').value = (attributes['gift-giver'] || attributes['gift-email']);
      if (this.giftForm.querySelector('#gift-email')) this.giftForm.querySelector('#gift-email').value = attributes['gift-email'];
      this.giftForm.querySelector('#gift-message').value = attributes['gift-message'];
    } else {
      this.giftEnabled = false;
      this.giftForm.querySelector('[name="attributes[is-gift]"]').checked = false;
    }
  }

  initGift() {
    const _this = this;
    this.giftModifier.addEventListener('change', function() {
      _this.giftEnabled = _this.notification.querySelector('[name="attributes[is-gift]"]').checked;
    });
  }

  validateGiftForm() {
    let error = false;
    if (this.giftEnabled) {
      this.giftForm.querySelector('.error-msg').classList.remove('active');
      const errorFields = this.giftForm.querySelectorAll('.error');
      for (var i = 0; i < errorFields.length; i++) {
        errorFields[i].classList.remove('error')
      }
      const requiredFields = this.giftForm.querySelectorAll('.required');
      for (var i = 0; i < requiredFields.length; i++) {
        if(requiredFields[i].value == "") {
          error = true;
          requiredFields[i].classList.add('error')
        }
      }
      
      if(error) {
        let  msg = 'Please complete the required fields or uncheck the \'This is a gift\' box.';
        this.giftForm.querySelector('.error-msg').textContent = msg;
        this.giftForm.querySelector('.error-msg').classList.add('active')
      } else {
        let emailField = this.giftForm.querySelector('#gift-email');
        if(emailField && emailField.value && !validateEmail(emailField.value)) {
          error = true;
          emailField.classList.add('error');
          this.giftForm.querySelector('.error-msg').textContent = 'Please provide a valid email address.';
          this.giftForm.querySelector('.error-msg').classList.add('active')
        }
      }
      if (!error) {
        let maxlength = 250;
        let combined = document.getElementById('gift-recipient').value + (document.getElementById('gift-giver') ? document.getElementById('gift-giver').value : document.getElementById('gift-email').value) + document.getElementById('gift-message').value;
        if (combined.length>maxlength) {
          error = true;
          document.getElementById('gift-recipient').classList.add('error');
          if (document.getElementById('gift-giver')) document.getElementById('gift-giver').classList.add('error');
          if (document.getElementById('gift-email')) document.getElementById('gift-email').classList.add('error');
          document.getElementById('gift-message').classList.add('error');
          this.giftForm.querySelector('.error-msg').textContent = '"To", "From" and "Gift message" combined can\'t exceed '+maxlength+' characters length.';
          this.giftForm.querySelector('.error-msg').classList.add('active')
        }
      }
    }
    return !error;
  }

  reChargeProcessCart() {
    function get_cookie(name) { return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
    var token;
    do {
      token=get_cookie('cart');
    }
    while(token == undefined);

    var myshopify_domain = Shopify.shop;
    try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
    var customer_param = ((typeof window.shopifyCustomer != 'undefined') ? `&customer_id=${window.shopifyCustomer.id}&customer_email=${window.shopifyCustomer.email}` : '');
    
    var discount_param = '';
    var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker+customer_param+discount_param;
    location.href = checkout_url;
  }

  submitForm() {
    if (this.hasNurseProducts == true && this.cartObject.total_price < 5000) return;
    if (this.giftEnabled) {
      const giftMessage = document.getElementById('gift-message').value.trim();
      let attributes = {
        attributes: (giftMessage == '' || giftMessage == null ?
          {
            'is-gift': null,
            'gift-recipient': null,
            'gift-message': null,
            'gift-giver': null,
            'gift-email': null
          } :
          {
            'is-gift': 'true',
            'gift-recipient': document.getElementById('gift-recipient').value,
            'gift-message': document.getElementById('gift-message').value
          }
        )
      };
      

      if (document.getElementById('gift-giver'))
        attributes['attributes']['gift-giver'] = document.getElementById('gift-giver').value;
      else
        attributes['attributes']['gift-email'] = document.getElementById('gift-email').value;
      const body = JSON.stringify(attributes);

      fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript', 'POST'), body })
        .then((response) => response.json())
        .then((cart) => {
          location.href = '/checkout'
        })
        .catch((e) => {
          console.error(e);
        })
    } else {
      if (this.cartObject.attributes['is-gift'] == 'true') {
        const body = JSON.stringify({
          attributes: {
            'is-gift': null,
            'gift-recipient': null,
            'gift-message': null,
            'gift-giver': null,
            'gift-email': null
          }
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig('javascript', 'POST'), body })
          .then((response) => response.json())
          .then((cart) => {
            location.href = '/checkout'
          })
          .catch((e) => {
            console.error(e);
          })
      } else {
        location.href = '/checkout'
      }
    }
  }

  initSubmit() {
    const _this = this;
    this.checkoutBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (_this.validateGiftForm()) {
        _this.submitForm();
      }
    });
  }
}

customElements.define('cart-notification', CartNotification);
